import { defineStore } from 'pinia';
import { throwErrorMessage } from 'dashboard/store/utils/api';
import LossReasonsAPI from 'dashboard/api/lossReasonsApi';

export const useLossReasonsStore = defineStore('lossReasons', {
  state: () => ({
    records: [],
    uiFlags: { fetching: false, saving: false },
  }),

  getters: {
    getList: state => state.records,
  },

  actions: {
    async get() {
      this.uiFlags.fetching = true;
      try {
        const { data } = await LossReasonsAPI.get();
        this.records = data.payload || [];
      } catch (error) {
        throwErrorMessage(error);
      } finally {
        this.uiFlags.fetching = false;
      }
    },

    async create(name) {
      this.uiFlags.saving = true;
      try {
        const { data } = await LossReasonsAPI.create({ name });
        this.records.push(data.payload);
        return data.payload;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        this.uiFlags.saving = false;
      }
    },

    async update(id, name) {
      this.uiFlags.saving = true;
      try {
        const { data } = await LossReasonsAPI.update(id, { name });
        const idx = this.records.findIndex(r => r.id === id);
        if (idx !== -1) this.records[idx] = data.payload;
        return data.payload;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        this.uiFlags.saving = false;
      }
    },

    async destroy(id) {
      try {
        await LossReasonsAPI.destroy(id);
        this.records = this.records.filter(r => r.id !== id);
      } catch (error) {
        throwErrorMessage(error);
      }
    },
  },
});
